import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import api from '@/utils/api';

const AutoLoginPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading'); // loading, success, error

  useEffect(() => {
    const autoLogin = async () => {
      const token = searchParams.get('token');

      if (!token) {
        setStatus('error');
        setTimeout(() => navigate('/auth'), 2000);
        return;
      }

      try {
        // Set the session token as a cookie
        document.cookie = `session_token=${token}; path=/; max-age=${30 * 24 * 60 * 60}; SameSite=None; Secure`;
        
        // Verify the token works by calling /auth/me
        const response = await api.get('/auth/me');
        
        if (response.data) {
          setStatus('success');
          // Redirect to dashboard after 1 second
          setTimeout(() => {
            window.location.href = '/dashboard';
          }, 1000);
        } else {
          throw new Error('Invalid token');
        }
      } catch (error) {
        console.error('Auto-login error:', error);
        setStatus('error');
        setTimeout(() => navigate('/auth'), 2000);
      }
    };

    autoLogin();
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-black via-zinc-900 to-black flex items-center justify-center">
      <div className="text-center">
        <img 
          src="/logo.png" 
          alt="AGRP BOX" 
          className="h-20 w-auto mx-auto mb-8"
        />
        
        {status === 'loading' && (
          <>
            <Loader2 className="w-12 h-12 text-[#E50914] animate-spin mx-auto mb-4" />
            <h2 className="text-white text-2xl font-bold mb-2">Connexion en cours...</h2>
            <p className="text-zinc-400">Veuillez patienter</p>
          </>
        )}
        
        {status === 'success' && (
          <>
            <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h2 className="text-white text-2xl font-bold mb-2">Connexion réussie !</h2>
            <p className="text-zinc-400">Redirection vers le dashboard...</p>
          </>
        )}
        
        {status === 'error' && (
          <>
            <div className="w-12 h-12 bg-red-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </div>
            <h2 className="text-white text-2xl font-bold mb-2">Échec de la connexion</h2>
            <p className="text-zinc-400">Lien invalide ou expiré. Redirection...</p>
          </>
        )}
      </div>
    </div>
  );
};

export default AutoLoginPage;
